import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d5e6cabc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "styles/dashboard/style.scss?vue&type=style&index=0&id=d5e6cabc&scoped=true&lang=css&"
import style1 from "styles/dashboard/datatable.scss?vue&type=style&index=1&id=d5e6cabc&scoped=true&lang=css&"
import style2 from "./index.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e6cabc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5e6cabc')) {
      api.createRecord('d5e6cabc', component.options)
    } else {
      api.reload('d5e6cabc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d5e6cabc&scoped=true&", function () {
      api.rerender('d5e6cabc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/performance/index.vue"
export default component.exports